import { useCallback, useState } from 'react';

export const useRequestAccountDeletionModal = () => {
  const [
    isShowingRequestAccountDeletionModal,
    setIsShowingRequestAccountDeletionModal,
  ] = useState(false);

  const showRequestAccountDeletionModal = useCallback(() => {
    setIsShowingRequestAccountDeletionModal(true);
  }, []);

  const hideRequestAccountDeletionModal = useCallback(() => {
    setIsShowingRequestAccountDeletionModal(false);
  }, []);

  return {
    isShowingRequestAccountDeletionModal,
    showRequestAccountDeletionModal,
    hideRequestAccountDeletionModal,
  };
};
